export const common = {
  hero: {
    badge: "Qatar's Premier Commercial Bridge",
    title1: "Connecting MENA",
    title2: "to Global",
    title3: "Opportunities",
    subtitle: "Strategic commercial brokerage services from the heart of Doha, facilitating seamless international trade across continents.",
    cta1: "Explore Services",
    cta2: "Contact Our Team"
  },
  about: "About",
  services: "Services",
  regional: "Regional Focus",
  faq: "FAQ",
  contact: "Contact",
  nav: {
    about: "About",
    services: "Services",
    regional: "Regional Focus",
    contact: "Contact",
    getStarted: "Get Started"
  }
};
